// import { HasPermission } from '../../Helper/Permisstions/Permisstions';

const financeMenu = [
  {
    System: 'FIN',
    isActive: false,
    menu: [
      { is_header: true, title: 'النظام المالي', isActive: true },

      {
        path: '/FINANCE/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      {
        path: '/FinanceSettings',
        icon: 'bi bi-gear',
        title: 'Settings',
        children: [
          // المجموعة الأولى: التقويم المالي
          {
            path: '/FINANCE/Settings/FiscalYear',
            title: 'السنة المالية',
            isActive: true
          },
          {
            path: '/FINANCE/Settings/AccountingPeriod',
            title: 'الفترات المحاسبية',
            isActive: true
          },

          // المجموعة الثانية: إعدادات الحسابات
          {
            path: '/FINANCE/Settings/ChartAccounts',
            title: 'الدليل المحاسبي',
            isActive: true
          },
          {
            path: '/FINANCE/Settings/Ledgers',
            title: 'الأستاذ العام',
            isActive: true
          },

          // المجموعة الثالثة: إعدادات القيود
          {
            path: '/FINANCE/Settings/JeCategory',
            title: 'تصنيفات القيود',
            isActive: true
          },
          {
            path: '/FINANCE/Settings/JeSource',
            title: 'مصادر القيود',
            isActive: true
          },

          // المجموعة الرابعة: المعاملات اليومية وأسعار العملات
          {
            path: '/FINANCE/Settings/DailyRates',
            title: 'المعدل اليومي للعملات',
            isActive: true
          },

          // المجموعة الخامسة: الضرائب والإدارات
          {
            path: '/FINANCE/Settings/VAT',
            title: 'ضريبة القيمة المضافة',
            isActive: true
          },
          {
            path: '/FINANCE/Settings/ConsolidationSet',
            title: 'الربط بين الإدارات',
            isActive: true
          },

          // المجموعة السادسة: المصروفات والحسابات البنكية
          {
            path: '/FINANCE/Settings/TypesOfExpenses',
            title: 'أنواع المصروفات',
            isActive: true
          },
          // {
          //   path: '/FINANCE/Settings/BankAccounts',
          //   title: 'الحسابات البنكية',
          //   isActive: true
          // },
          // {
          //   path: '/FINANCE/Settings/CashBoxes',
          //   title: 'صناديق النقديــة',
          //   isActive: true
          // },

          // المجموعة السابعة: الميزانية
          {
            path: '/FINANCE/Budget',
            title: 'الموازنة',
            isActive: true
          }
        ]
      },

      { is_header: true, title: 'القيــود', isActive: true },

      {
        path: '/FINANCE/Journals',
        title: 'القيود اليومية',
        icon: 'bi bi-journal-text',
        isActive: true
      },
      {
        path: '/FINANCE/PostingJournals',
        title: 'ترحيــل القيود',
        icon: 'bi bi-arrow-right-square',
        isActive: true
      },

      {
        path: '/FINANCE/ControlCodeCombinations',
        icon: 'fas fa-sliders-h',
        // title: 'Control Code Combinations',
        title: 'التحكم في تسجيل الحسابات',
        isActive: true
      },
      // {
      //   path: '/FINANCE/CashTransfer',
      //   icon: 'fas fa-exchange-alt',
      //   title: 'التحويل النقدي',
      //   isActive: true
      // },

      { is_header: true, title: 'التقاريــر الماليــة', isActive: true },
      {
        path: '/FINANCE/Report/IncomeStatement',
        title: 'قائمة الدخل',
        icon: 'bi bi-file-earmark-text',
        isActive: true
      },
      {
        path: '/FINANCE/Report/BalanceSheet',
        title: 'المركـر المالي',
        icon: 'bi bi-file-spreadsheet',
        isActive: true
      },
      {
        path: '/FINANCE/Report/AuditBalance/',
        title: 'ميزان المراجعة',
        icon: 'bi bi-list-check',
        isActive: true
      },
      {
        path: '/FINANCE/Report/AccountStatement',
        title: 'كشف حساب',
        icon: 'bi bi-list-check',
        isActive: true
      },

      { is_header: true, title: 'Reports', isActive: true },

      {
        path: '/FINANCE/Reports',
        icon: 'fas fa-chart-bar',
        title: 'Reports',
        isActive: true
      },

      {
        path: '/FINANCE/Dashboard',
        icon: 'bi bi-cpu',
        title: 'Dashboard',
        isActive: true
      }
    ]
  }
];

export default financeMenu;
